export default __webpack_public_path__ + "static/media/06.cc4034b1.jpg";